let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1dMfP")).then(() => parcelRequire('3KXjR'));